import { render, staticRenderFns } from "./OcorrenciasProcesso.vue?vue&type=template&id=2ffa6028"
import script from "./OcorrenciasProcesso.vue?vue&type=script&lang=js"
export * from "./OcorrenciasProcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports